import { Alert, Stack } from "@mui/material";
import { useContext } from "react";
import AppConfirmationLabel from "src/pages/Link/DynamicForm/components/AppConfirmationLabel";

import ThemeContext from "../../context";
import CustomConnectBtn from "../DConnectBtn/CustomConnectBtn";
// ----------------------------------------------------------------------

type Props = {
	isLoading?: boolean;
	errorMessage?: string;
};

export default function UpdateUserConfirmation({ isLoading, errorMessage }: Props) {
	const { entity } = useContext(ThemeContext);

	return (
		<Stack>
			{errorMessage && !entity?.maintenance && (
				<Alert severity='error' sx={{ mx: 3, mb: 4 }}>
					{errorMessage}
				</Alert>
			)}
			<Stack spacing={3} sx={{ mb: 3 }}>
				{!errorMessage && !entity?.maintenance && <AppConfirmationLabel />}
			</Stack>
			<CustomConnectBtn loading={isLoading} userConfirmationNeeded={true} />
		</Stack>
	);
}
